import axios from '@/http/axios'

export function getProvinces () {

  return axios({
    url: 'v1/provinces',
    method: 'get'
  })
}
